package com.essntl.features.price.domain.model.supplierserviceprice

import com.essntl.features.currency.domain.model.CurrencyModel
import com.essntl.features.service.domain.model.supplierservice.SupplierServiceModel

data class SupplierServicePriceModel(
    val id: String,
    val description: String,
    val price: Int,
    val createdAt: String,
    val updatedAt: String,
    val minPax: Int?,
    val maxPax: Int?,
    val taxRate: Double?,
    val currency: CurrencyModel?,
    val startDate: String?,
    val endDate: String?,
    val minAge: Int?,
    val maxAge: Int?,
    val hours: List<String>?,
    val duration: Double?,
    val daysValid: List<Int>?,
    val terms: String?,
    val supplierService: SupplierServiceModel?,
    val defaultSellingPrice: Int?,
    val calculation: String?,
    val updatedBy: String?,
)